// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-dialog .p-dialog-footer,
.p-dialog .p-dialog-content,
.p-dialog .p-dialog-header,
.p-dialog {
    background: var(--blue-dark);
    color: white;
    font-family: 'Montserrat', sans-serif; /* Default font */

}
`, "",{"version":3,"sources":["webpack://./src/css/dialog.css"],"names":[],"mappings":"AAAA;;;;IAII,4BAA4B;IAC5B,YAAY;IACZ,qCAAqC,EAAE,iBAAiB;;AAE5D","sourcesContent":[".p-dialog .p-dialog-footer,\n.p-dialog .p-dialog-content,\n.p-dialog .p-dialog-header,\n.p-dialog {\n    background: var(--blue-dark);\n    color: white;\n    font-family: 'Montserrat', sans-serif; /* Default font */\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
